import React from 'react';
import cm from 'classnames';
import type { ReactElement } from 'react';

import styles from './Status.module.scss';

interface IStatus {
  titleStatus: string;
  result: string;
  gap: number;
}

export const Status = ({ titleStatus, result, gap = 16 }: IStatus): ReactElement => {
  const style = { gap: `${gap}px` };
  return (
    <div className={styles.status} style={style}>
      <div
        className={cm(styles.circle, {
          [styles.green]: result === 'S',
          [styles.yellow]: result === 'W',
          [styles.red]: result === 'E',
        })}
      />
      <p className={styles.statusText}>{titleStatus}</p>
    </div>
  );
};
